export enum CallTypes {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
  OUTBOUND_AGENT = 'outbound-agent',
  OUTBOUND_LEAD = 'outbound-lead',
  ISA_OUTBOUND = 'isa-outbound',
}

export enum CallResponse {
  ANSWERED = 'answered',
  FORWARDED = 'forwarded',
  MISSED = 'missed',
  REJECTED = 'rejected',
}

export enum ConciergeActions {
  SMS = 'sms',
  EMAIL = 'email',
  CALL = 'call',
  NOTE = 'note',
  AUTOMATIC = 'Automatic',
}

export enum CommunicationTypes {
  SMS = 'sms',
  EMAIL = 'email',
  CALL = 'call',
  NOTE = 'note',
}

export enum CommunicationActions {
  FLAG = 'FLAG',
  RATE = 'RATE',
  REMOVE_ISSUE = 'REMOVE_ISSUE',
  REPORT_ISSUE = 'REPORT_ISSUE',
}

export enum ConnectionState {
  INITIALIZED = 'initialized',
  CONNECTED = 'connected',
  UNAVAILABLE = 'unavailable',
}

export enum LeadStatus {
  QUALIFIED = 'Qualified',
  UNQUALIFIED = 'Unqualified',
  NEW_LEAD = 'New lead',
  BAD_LEAD_TECH_SUPPORT = 'Bad Lead / Tech Support',
  GOOD_EMAIL_BAD_PHONE = 'Good email / bad phone',
}

export enum LeadTag {
  URGENT = 'Urgent',
  AWAITING_RESPONSE = 'Awaiting Response',
  ACTION_REQUIRED = 'Action Required',
  ONGOING_CHAT = 'Ongoing Chat',
  INBOUND_CALL = 'Inbound Call',
  AUTOMATION = 'Automation',
  ARCHIVE = 'Archive',
  CONVO_ENDED = 'Convo Ended',
}

export enum LeadType {
  MORTGAGE = 'mortgage',
  REFI = 'refi',
  BUYER = 'buyer',
  SELLER = 'seller',
}

export enum LeadIcon {
  AUTO = 'auto',
  GENERAL = 'general',
  SMS = 'sms',
  CALL = 'call',
  EMAIL = 'email',
}

export enum NoteTypes {
  QUALIFY = 'Qualify',
  REOPEN = 'Reopen',
  UNQUALIFY = 'Unqualify',
  BAD_LEAD_TECH_SUPPORT = 'Bad Lead / Tech Support',
  GOOD_EMAIL_BAD_PHONE = 'Good email / bad phone',
  CONTINUE_SMS_AUTOMATION = 'Continue SMS Automation',
  CONTINUE_LANDLINE_AUTOMATION = 'Continue Landline Automation',
  CALL_REQUESTED = 'Call Requested',
  FOLLOW_UP_REQUESTED = 'Follow Up Requested',
  NO_RESPONSE_NEEDED = 'No Response Needed',
  EMAIL_UNSUBSCRIBE = 'Email Unsubscribe',
  AGENT_NOTE = 'Agent',
  ADMIN_NOTE = 'Admin Note',
}

export enum PhoneCarrierTypes {
  LANDLINE = 'landline',
  MOBILE = 'mobile',
  VOIP = 'voip',
}

export enum UnqualifyReasonGroups {
  CRITERIA_NOT_MET = 1,
  STOP_CONTACT = 2,
  NOT_INTERESTED = 3,
  SPAM = 4,
  INACCURATE_CONTACT_INFO = 5,
  TEST = 6,
  DUPLICATE = 7,
  UNRESPONSIVE = 8,
  KNOWN_LITIGATOR = 9,
}

export enum LeadUpdateActions {
  UPDATE = 'UPDATE',
  CONTINUE_AUTOMATION = 'Continue Automation',
  NO_RESPONSE_NEEDED = 'No Response Needed',
  GOOD_EMAIL_BAD_PHONE = 'Good email / bad phone',
  SCHEDULE_FOLLOW_UP = 'Schedule Follow Up',
  SCHEDULE_CALL_IMMEDIATELY = 'Schedule Call Immediately',
  ESCALATE_LEAD = 'Escalate Lead',
  STOP_CONTACT = 'Stop Contact',
  NEW_LEAD = 'New lead',
  QUALIFY = 'Qualify',
  UNQUALIFY = 'Unqualify',
  BAD_LEAD_TECH_SUPPORT = 'Bad Lead / Tech Support',
  CANCEL_APPOINTMENT = 'Cancel Appointment',
}

export enum ScriptLeadStatusActions {
  QUALIFY = 'qualify',
  UNQUALIFY = 'unqualify',
  GOOD_EMAIL_BAD_PHONE = 'good email bad phone',
}

export enum LastActions {
  CALL_REQUESTED = 'Call Requested',
  FOLLOW_UP_REQUESTED = 'Follow Up Requested',
  NO_RESPONSE_NEEDED = 'No Response Needed',
  GOOD_EMAIL_BAD_PHONE = 'Good email / bad phone',
  ESCALATE_LEAD = 'Escalate Lead',
  UNQUALIFY = 'Unqualify',
}

export enum UnqualifyReasons {
  STOP_CONTACT = 'Stop Contact',
}

export enum ScheduleFollowUpTimeFrames {
  CUSTOM = 'custom',
  TOMORROW = 'tomorrow',
  NEXT_WEEK = 'next week',
  NEXT_MONTH = 'next month',
}

export enum Colors {
  GREEN = '#29D773',
  LIGHT_GREEN = '#33CC99',
  RED = '#F5532D',
  DARK_RED = '#B50000',
  ORANGE = '#F6A623',
  LIGHT_ORANGE = '#CC9933',
  PALE_BLUE = '#ECF4FE',
  LIGHT_BLUE = '#36AEFF',
  BLUE = '#4397ED',
  DARK_BLUE = '#1665A5',
  LIGHT_PURPLE = '#9933CC',
  PURPLE = '#A123F6',
  DARK_PURPLE = '#6A00C4',
  PALE_GRAY = '#F5F5F5',
  LIGHT_GRAY = '#B5B5B5BF',
  MEDIUM_GRAY = '#888888',
  TRANSPARENT_BLACK = '#00000029',
  BLACK = '#000000',
  WHITE = '#FFFFFF',
  WHITE_ISH = '#EDEDED',
}

export enum AppCopyText {
  // General error message
  ACTION_ERROR_MESSAGE = 'Something went wrong while performing this action',
  // Inbound call messages
  INBOUND_CALL_ENDED = 'Inbound call ended',
  INBOUND_CALL_GONE = 'Inbound call ended by lead',
  LIVE_TRANSFER_UNSUCCESSFUL = 'Live Transfer did not succeed',
  // Good email / bad phone messages
  BAD_PHONE_REASON = 'Wrong number, continuing outreach by email',
  // Bad data messages
  INVALID_PHONE = 'Phone number is not valid',
  PUSHER_CONNECTION_ERROR = 'Pusher connection error',
}

export enum ConciergeRatingSentiments {
  GOOD = '1',
  BAD = '2',
  NEUTRAL = '3',
}

export enum SystemErrors {
  CORE_API = 'The system is currently experiencing issues, please notify engineering if this issue persists.',
  LOGIN = `Login Failed, as the system is currently experiencing issues, please notify engineering if this issue persists.`,
}

export enum LoadingStates {
  LOADING = 'loading',
  LOADED = 'loaded',
  NOT_LOADED = 'not-loaded',
}
